import React, { useState, useEffect } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import ClientCombo from '../../combos/ClientCombo.jsx';
import ProductCombo from '../../combos/ProductCombo.jsx';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintContraxtBill from '../../prints/PrintContraxtBill.jsx';
import { InputTextarea } from 'primereact/inputtextarea';
import ServiceCombo from '../../combos/ServiceCombo.jsx';

var editedModules = [];
var editedParameters = {};
export default function BuyServiceList(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [buyServices, setBuyServices] = useState([]);
    const [buyServiceIndex, setBuyServiceIndex] = useState(-1);
    const [buyNo, setBuyNo] = useState(0);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [confirmChangeStateVisible, setConfirmChangeStateVisible] = useState(false);
    const [searchPanelVisible, setSearchPanelVisible] = useState(false);
    const [searchOptions, setSearchOptions] = useState({client:null, includeDone:true, includeNotDone:true, fromDate:0, toDate:0, searchText:"", service:null});
    const [buyService, setBuyService] = useState(null);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var userId = "";
        var serviceId = "";
        var includeDone = true;
        var includeNotDone = true;
        var searchText = "";
        var fromDate = 0;
        var toDate = 0;
        if(searchOptions != null){
            if(searchOptions.client != null)userId = searchOptions.client.id;
            includeDone = searchOptions.includeDone;
            includeNotDone = searchOptions.includeNotDone;
            searchText = searchOptions.searchText;
            if(searchOptions.service != null)serviceId = searchOptions.service.id;
            fromDate = searchOptions.fromDate;
            toDate = searchOptions.toDate;
        }
        var params = {
            login:util.getLoginDto(), 
            userId:userId,
            serviceId:serviceId,
            includeDone:includeDone,
            includeNotDone:includeNotDone,
            searchText:searchText,
            fromDate:fromDate,
            toDate:toDate,
        };
        var url = config.Server+`/contract/services/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setBuyServices is> ", response);
                setBuyServices(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onRowDeleteClick = function(c, cInd){
        setBuyService(c);
        setBuyServiceIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const onRowChangeStateClick = function(c, cInd){
        setBuyService(c);
        setBuyServiceIndex(cInd);
        setConfirmChangeStateVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowChangeStateClick(row, cInd)} title="تغیر وضعیت" />
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    //=====================================================================================================================================
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:buyService.id};
        var url = config.Server+`/contract/buy-service/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...buyServices];
                ncs.splice(buyServiceIndex, 1);
                setBuyServices(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
    //=====================================================================================================================================
    const changeStateItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:buyService.id};
        var url = config.Server+`/contract/buy-service/change/state`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...buyServices];
                ncs[buyServiceIndex] = {...response.data};
                setBuyServices(ncs);
                console.log("ncs is>", ncs)

                setDeleting(false);
                setConfirmChangeStateVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onChangeStateConfirm_Accept = function(){
      changeStateItem();
    }
    const onChangeStateConfirm_Reject = function(){
        if(deleting) return;
        setConfirmChangeStateVisible(false);
    }
    const onSearchInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        var so = {...searchOptions};
        if((name === "searchText")) so[name] = val;
        setSearchOptions(so);
    }
    const onSearchServiceSelected = function(value){
        console.log("selected service is>", value)
        var so = {...searchOptions};
        if(value){
            so["service"] = value;
        }
        else{
            so["service"] = null;
        }
        setSearchOptions(so);
        
    }
    const onSearchClientSelected = function(value){
        console.log("selected product is>", value)
        var so = {...searchOptions};
        if(value){
            so["client"] = value;
        }
        else{
            so["client"] = null;
        }
        setSearchOptions(so);
        
    }
    const setRowState = function (row, cInd) {
        var color = "#1ea01eff";
        var text = "انجام شده";
        if(!row.isDone){
            color = "#ff0000";
            text = "منتظر انجام";
        }
        return(
            <>
                <div style={{display:"inline-block", width:"16px", height:"16px", borderRadius:"50%", backgroundColor:color}}></div>
                <label style={{color:color}}>&nbsp;{text}</label>
            </>
        )
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست درخواست های خدمات..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست درخواست های خدمات
            </div>
            {
              searchPanelVisible?
              <Row style={{border:"1px dashed #b0b0b0", padding:"5px", margin:"10px 0px 0px 0px"}}>
                <Col md={3} style={{marginTop:"0px"}}>
                    <ClientCombo onChange={(val)=>{onSearchClientSelected(val)}} value={searchOptions.client} includeAdmins={false} includeAssistants={false} includeAgents={true} includeClients={true}/>
                </Col>
                <Col md={3} style={{marginTop:"0px"}}>                
                    <ServiceCombo onChange={(val)=>{onSearchServiceSelected(val);}} value={searchOptions.service} />
                </Col>
                <Col md={12} style={{marginTop:"30px"}}>
                    <Button label="&nbsp;&nbsp;  جستجو کن  &nbsp;&nbsp;" icon="pi pi-search" onClick={()=>loadItems()} severity="primary" iconPos="right" style={{borderRadius:"5px"}} />
                </Col>
              </Row>
              :<></>
            }


              <DataTable value={buyServices} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="buyService.id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="buyNo" header={"شماره"} body={(row) => (util.toPersianDigits(row.buyNo) )} sortable className="list-cell-text-align"></Column>
                <Column field="buyDate" header={"تاریخ"} body={(row, options) => (util.toPersianDigits(util.SeperateDate(row.buyDate)) )} sortable className="list-cell-text-align"></Column>
                <Column field="buyTime" header={"زمان"} body={(row, options) => (util.toPersianDigits(util.SeperateTime(row.buyTime)) )} sortable className="list-cell-text-align"></Column>
                <Column field="user.lastname" body={(row) => (row.user.mobile + " " + row.user.firstname + " " + row.user.lastname)} header={"مشتری"} sortable className="list-cell-text-align"></Column>
                <Column field="service.title" body={(row) => row.service.title} header={"نوع خدمت"} sortable className="list-cell-text-align"></Column>
                <Column field="serviceNumber" header={"تعداد"} body={(row) => (util.toPersianDigits(row.serviceNumber) )} sortable className="list-cell-text-align"></Column>
                <Column field="comment" header={"شرح"} sortable className="list-cell-text-align"></Column>
                <Column field="isDone" header={"وضعیت"} body={(row, options) => setRowState(row, options.rowIndex)} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>


            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
            <ShowConfirm visible={confirmChangeStateVisible} message="آیا از تغیر وضعیت مطمئن هستید؟" caption="اطمینان از تغیر وضعیت" onAccept={onChangeStateConfirm_Accept} onReject={onChangeStateConfirm_Reject} loading={deleting} />
        </>
    )
}